// extracted by mini-css-extract-plugin
module.exports = {"immediatePromoPriceContainer":"PromoPrice_immediatePromoPriceContainer__xZRix","batchPromoPriceContainer":"PromoPrice_batchPromoPriceContainer__YfvMS"};